import { Fields } from '@app/sharedModule/components/rules-dynamic-form/model';
import { RuleEntity, RuleOperator } from '@pdqdev/pdq-shared/dist/entities/Rules';

export const TrackingPageCouponCodeRules = [
  {
    entity: RuleEntity.CUSTOMER_ORDER_COUNT,
    entityOperator: {
      fieldType: Fields.DROP_DOWN,
      defaultValue: { label: RuleOperator.IS_EQUAL, value: RuleOperator.IS_EQUAL },
      operators: [
        {
          label: RuleOperator.IS_EQUAL,
          value: RuleOperator.IS_EQUAL,
        },
        {
          label: RuleOperator.IS_MORE_THAN_OR_EQUAL,
          value: RuleOperator.IS_MORE_THAN_OR_EQUAL,
        },
        {
          label: RuleOperator.IS_LESS_THAN_OR_EQUAL,
          value: RuleOperator.IS_LESS_THAN_OR_EQUAL,
        },
      ],
    },
    entityParams: [
      {
        required: true,
        name: 'customerOrderCountValue',
        defaultValue: 0 + '',
        fieldType: Fields.ARROW_INPUT,
        min: 0,
      },
    ],
  },
  {
    entity: RuleEntity.DELIVERY_AREA_COUNTRIES,
    entityOperator: {
      fieldType: Fields.DROP_DOWN,
      defaultValue: { label: RuleOperator.IS, value: RuleOperator.IS },
      operators: [
        {
          label: RuleOperator.IS,
          value: RuleOperator.IS,
        },
        {
          label: RuleOperator.IS_NOT,
          value: RuleOperator.IS_NOT,
        },
      ],
    },
    entityParams: [
      {
        required: true,
        name: 'deliveryCountriesValue',
        defaultValue: '',
        operatorsSupportAutocompleteMode: [RuleOperator.IS_NOT, RuleOperator.IS],
        fieldType: Fields.INPUT,
      },
    ],
  },
  {
    entity: RuleEntity.DELIVERY_AREA_STATES,
    entityOperator: {
      fieldType: Fields.DROP_DOWN,
      defaultValue: { label: RuleOperator.IS, value: RuleOperator.IS },
      operators: [
        {
          label: RuleOperator.IS,
          value: RuleOperator.IS,
        },
        {
          label: RuleOperator.IS_NOT,
          value: RuleOperator.IS_NOT,
        },
      ],
    },
    entityParams: [
      {
        required: true,
        name: 'deliveryStatesValue',
        defaultValue: '',
        operatorsSupportAutocompleteMode: [RuleOperator.IS_NOT, RuleOperator.IS],
        fieldType: Fields.INPUT,
      },
    ],
  },
  // {
  //   entity: RuleEntity.ON_TIME_STATUS,
  //   entityOperator: {
  //     fieldType: Fields.DROP_DOWN,
  //     defaultValue: { label: RuleOperator.IS, value: RuleOperator.IS },
  //     operators: [
  //       {
  //         label: RuleOperator.IS,
  //         value: RuleOperator.IS,
  //       },
  //       {
  //         label: RuleOperator.IS_NOT,
  //         value: RuleOperator.IS_NOT,
  //       },
  //     ],
  //   },
  //   entityParams: [
  //     {
  //       required: true,
  //       name: 'onTimeStatusValue',
  //       defaultValue: '',
  //       fieldType: Fields.DROP_DOWN,
  //       options: [
  //         {
  //           label: 'Early',
  //           value: ShopPlugin.TrackingPage.OnTimeStatus.EARLY,
  //         },
  //         {
  //           label: 'Late',
  //           value: ShopPlugin.TrackingPage.OnTimeStatus.LATE,
  //         },
  //         {
  //           label: 'On time',
  //           value: ShopPlugin.TrackingPage.OnTimeStatus.ON_TIME,
  //         },
  //       ],
  //     },
  //   ],
  // },
  {
    entity: RuleEntity.NUMBER_OF_DAYS_LATE,
    entityOperator: {
      fieldType: Fields.DROP_DOWN,
      defaultValue: { label: RuleOperator.IS_EQUAL, value: RuleOperator.IS_EQUAL },
      operators: [
        {
          label: RuleOperator.IS_EQUAL,
          value: RuleOperator.IS_EQUAL,
        },
        {
          label: RuleOperator.IS_MORE_THAN_OR_EQUAL,
          value: RuleOperator.IS_MORE_THAN_OR_EQUAL,
        },
        {
          label: RuleOperator.IS_LESS_THAN_OR_EQUAL,
          value: RuleOperator.IS_LESS_THAN_OR_EQUAL,
        },
      ],
    },
    entityParams: [
      {
        required: true,
        name: 'numOfDaysLateValue',
        defaultValue: 1 + '',
        fieldType: Fields.ARROW_INPUT,
        min: 1,
      },
    ],
  },
];
